import Vue from 'vue'

import './plugins/axios'
import './plugins/notification'
import './plugins/select2'
import './plugins/telinput'

import Component from './components/CourseDetails.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(Component)
}).$mount('#course-details')
